import { Environment } from './environment.interface';
import { LogLevel } from '../app/providers/logger.service';

export const environment: Environment = {
  local: false,
  serverRenderingTimeout: 10 * 60 * 1000, // 10 minutes
  loggers: {
    server: LogLevel.Info,
    renderer: LogLevel.Warning,
    access: LogLevel.Warning,
    performance: LogLevel.Warning,
    cache: LogLevel.Warning,
    httpClient: LogLevel.Warning,
  },
  serverHttpClientTimeout: 25 * 1000, // 25 seconds
  serviceWorker: true,
  firstSpirit: false,
  transferHttpCache: {
    url: {
      serverClientReplacement: {
        'http://static.knorr-bremse.com.localhost/': 'https://static.knorr-bremse.com/',
        'http://haupia.knorr-bremse.com.localhost/': 'https://haupia.knorr-bremse.com/',
        'http://api.knorr-bremse.com.localhost/': 'https://api.knorr-bremse.com/',
      },
    },
  },
  contentRepositoryService: {
    urlTransformers: [
      {
        searchRegex: new RegExp(''),
        replaceValue: 'https://static.knorr-bremse.com/${location.hostname}',
      },
    ],
    serverUrlTransformers: [
      {
        searchRegex: new RegExp(''),
        replaceValue: 'http://static.knorr-bremse.com.localhost/${location.hostname}',
      },
    ],
  },
  globalSettingsPath: '/en/global-settings.json',
  mapsApiKey: 'AIzaSyAqIQ9GoaaOfn2_UwmL-PVvXMBCSK0aQNI',
  locationFinder: {
    mapId: '272c56a3b47649f',
  },
  googleTagManagerService: {
    // id: 'GTM-K5BGWNB'
  },
  haupiaService: {
    baseUrl: new URL('https://haupia.knorr-bremse.com/haupia/search/'),
    onServer: {
      baseUrl: new URL('http://haupia.knorr-bremse.com.localhost/haupia/search/'),
    },
  },
  captchaService: {
    baseUrl: new URL('https://api.knorr-bremse.com/captcha'),
  },
  dynamicForms: {
    baseUrl: new URL('https://api.knorr-bremse.com/dynamic-forms'),
  },
  stockService: {
    baseUrl: new URL('https://api.knorr-bremse.com/stock-market'),
    onServer: {
      baseUrl: new URL('http://api.knorr-bremse.com.localhost/stock-market'),
    },
    refreshInterval: 20000,
  },
  youtubeMetadataService: {
    baseUrl: new URL( 'https://api.knorr-bremse.com/youtube-meta-proxy'),
    onServer: {
      baseUrl: new URL('http://api.knorr-bremse.com.localhost/youtube-meta-proxy'),
    },
  },
  oneTrustService: {
    production: true,
  },
  mapp: {
    enabled: true,
    production: true,
  },
  standalone: {
    urlTransformers: [
      {
        searchRegex: /\/en(.+)\/cookies?\/?/,
        replaceValue: 'https://newsroom.knorr-bremse.com/en/cookies-en/',
      },
      {
        searchRegex: /\/de(.+)\/cookies?\/?/,
        replaceValue: 'https://newsroom.knorr-bremse.com/cookies/',
      },
    ],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
